﻿/**
 * Főmenü, ami mobil nézetekben nyitható és zárható
 */
export default class EventHandler {
    private _listeners: { [id: string]: Array<Function> } = {};

    /**
     * Eseményre történő feliratkozás
     * 
     * @param type
     * @param listener
     */
    addEventListener(type: string, listener: Function) {
        if (!this._listeners[type]) {
            this._listeners[type] = new Array<Function>();
        }

        this._listeners[type].push(listener);
    }

    /**
     * Eseményre feliratkozott függvények meghívása
     * 
     * @param type
     */
    trigger(type: string) {
        if (this._listeners[type]) {
            this._listeners[type].forEach((value: Function) => {
                value();
            });
        }
    }
}